import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import CorporateAccount from '@iso/redux/corporateAccount/reducer';
import Mqtt from '@iso/redux/mqtt/reducer';
import Settings from '@iso/redux/settings/reducer';


export default combineReducers({
  Auth,
  App,
  LanguageSwitcher,
  ThemeSwitcher,
  CorporateAccount,
  Mqtt,
  Settings,
});
